// src/components/ui/PortalIcon.jsx
const PATHS = {
  achievement: "M12 3l2.2 4.5 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L4.8 8.2l5-.7L12 3z",
  arrowLeft: "M19 12H5m0 0 6-6m-6 6 6 6",
  arrowRight: "M5 12h14m0 0-6-6m6 6-6 6",
  award: "M8 3h8v5a4 4 0 0 1-8 0V3zm2 12l-2 6 4-2 4 2-2-6",
  bag: "M7 8h10l1 12H6L7 8zm2 0a3 3 0 0 1 6 0",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4",
  book: "M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21V5.5zM4 5.5V21",
  calendar: "M7 3v4M17 3v4M4 8h16M5 5h14v16H5V5z",
  card: "M3 6h18v12H3V6zm0 4h18M7 15h4",
  cart: "M3 4h2l2.2 10h9.8l2-7H6.2M9 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
  certificate: "M6 3h12v18l-6-3-6 3V3zm3 5h6M9 12h6",
  chat: "M21 12a8 8 0 0 1-8 8H6l-3 3v-7a8 8 0 1 1 18-4z",
  check: "M20 6 9 17l-5-5",
  chevronDown: "M6 9l6 6 6-6",
  chevronUp: "M18 15l-6-6-6 6",
  clipboard: "M9 4h6l1 2h3v16H5V6h3l1-2zm0 5h6M9 13h6M9 17h4",
  clock: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-14v5l3 2",
  course: "M4 6.5 12 3l8 3.5-8 3.5-8-3.5zm3 3v5c0 1.7 2.2 3 5 3s5-1.3 5-3v-5",
  dashboard: "M4 13h6V4H4v9zm10 7h6V4h-6v16zM4 20h6v-4H4v4z",
  download: "M12 3v12m0 0 5-5m-5 5-5-5M5 21h14",
  edit: "M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z",
  eye: "M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  eyeOff: "M3 3l18 18M10.6 10.6A3 3 0 0 0 13.4 13.4M9.9 5.2A10.6 10.6 0 0 1 12 5c6.5 0 10 7 10 7a17.7 17.7 0 0 1-3.2 4.2M6.5 6.5C3.7 8.1 2 12 2 12s3.5 7 10 7c1.4 0 2.7-.3 3.8-.8",
  file: "M14 3H6v18h12V7l-4-4zM14 3v4h4M8 13h8M8 17h6",
  flame: "M12 22c4 0 7-3 7-7 0-3-2-5-4-7 .2 2-1 3-2 4 0-4-2-7-5-9 .5 4-3 6-3 10 0 5 3 9 7 9z",
  folder: "M3 6h7l2 2h9v11H3V6z",
  globe: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm-4-10h8M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20",
  image: "M4 5h16v14H4V5zm3 10 3-3 3 3 2-2 3 3M8.5 9.5h.01",
  info: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-10v5m0-9h.01",
  keyboard: "M4 7h16v10H4V7zm3 3h.01M10 10h.01M13 10h.01M16 10h.01M7 14h10",
  link: "M10 13a5 5 0 0 0 7.1 0l2-2a5 5 0 0 0-7.1-7.1l-1.2 1.2M14 11a5 5 0 0 0-7.1 0l-2 2A5 5 0 0 0 12 20l1.2-1.2",
  login: "M10 17l5-5-5-5M15 12H3M21 3v18",
  logout: "M14 8V5a2 2 0 0 0-2-2H5v18h7a2 2 0 0 0 2-2v-3M9 12h12m-4-4 4 4-4 4",
  mail: "M4 6h16v12H4V6zm0 0 8 7 8-7",
  menu: "M4 7h16M4 12h16M4 17h16",
  moon: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9z",
  zap: "M13 2L4.5 13H11L10 22L19.5 11H13L13 2z",
  package: "M21 8l-9-5-9 5 9 5 9-5zm-18 0v8l9 5 9-5V8M12 13v8",
  palette: "M12 3a9 9 0 0 0 0 18h1.5a2 2 0 0 0 1.5-3.3 1.5 1.5 0 0 1 1.1-2.7H18a6 6 0 0 0 0-12h-6zM7.5 10h.01M10 7h.01M14 7h.01M16.5 10h.01",
  phone: "M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6.1 6.1l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z",
  play: "M8 5v14l11-7L8 5z",
  plus: "M12 5v14M5 12h14",
  profile: "M20 21a8 8 0 0 0-16 0M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z",
  refresh: "M21 12a9 9 0 0 1-15.4 6.4L3 16m0 0v5h5M3 12A9 9 0 0 1 18.4 5.6L21 8m0 0V3h-5",
  rupee: "M6 4h12M6 8h12M7 4c6 0 6 8 0 8h-1l7 8",
  search: "M21 21l-4.3-4.3M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z",
  settings: "M12 15.5A3.5 3.5 0 1 0 12 8a3.5 3.5 0 0 0 0 7.5zm0-13v3m0 13v3m9.5-9.5h-3m-13 0h-3m16.3-6.3-2.1 2.1m-9.4 9.4-2.1 2.1m0-13.6 2.1 2.1m9.4 9.4 2.1 2.1",
  shield: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  school: "M4 10 12 5l8 5v9H4v-9zm3 9v-6h10v6M9 19v-4h6v4",
  send: "M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z",
  sliders: "M4 7h10M18 7h2M16 5v4M4 17h2M10 17h10M8 15v4M4 12h3M11 12h9M9 10v4",
  star: "M12 3l2.2 4.5 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L4.8 8.2l5-.7L12 3z",
  store: "M4 10h16l-1 11H5L4 10zm2-5h12l2 5H4l2-5z",
  sun: "M12 4V2m0 20v-2M4.9 4.9 3.5 3.5m17 17-1.4-1.4M4 12H2m20 0h-2M4.9 19.1l-1.4 1.4m17-17-1.4 1.4M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  trash: "M3 6h18M8 6V4h8v2m-10 0 1 15h10l1-15M10 11v6M14 11v6",
  user: "M20 21a8 8 0 0 0-16 0M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z",
  x: "M18 6 6 18M6 6l12 12",
};

export default function PortalIcon({ name, size = 18, stroke = 2, style }) {
  const path = PATHS[name] || PATHS.info;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ display:"inline-block", verticalAlign:"middle", flexShrink:0, ...style }}>
      <path d={path} />
    </svg>
  );
}
